import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import PageWrapper from "../../../../components/common/layout/PageWrapper";

import {
  CircularLoader,
  AlertSpg,
  AsyncCallArgs,
  useAsyncCall,
  AppPageContentWrapper,
} from "@duosoftbg/nacid-components";
import { getSecondaryByQrCodeUUID } from "../../../../../axios/api/services";
import SeRecognitionContent from "../../../../components/seRecognition/SeRecognitionContent";

const SeRecognitionQrView = () => {
  const { t } = useTranslation();
  const { asyncCall } = useAsyncCall();
  const [searchParams] = useSearchParams();
  const qrCodeUUID = searchParams.get("qrCodeUUID");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (qrCodeUUID) {
      const asyncCallArgs: AsyncCallArgs = {
        promise: getSecondaryByQrCodeUUID(qrCodeUUID),
        onSuccess: (response) => {
          if (response) {
            setLoading(false);
            setError(false);
            setData(response);
          } else {
            setLoading(false);
            setError(true);
          }
        },
        onError: () => {
          setLoading(false);
          setError(true);
        },
      };
      asyncCall(asyncCallArgs);
    } else {
      setLoading(false);
      setError(false);
    }
  }, [qrCodeUUID]);

  return (
    <PageWrapper title={t(`t.seRecognition.qr.view`)}>
      <AppPageContentWrapper>
        {loading && <CircularLoader />}
        {error && (
          <AlertSpg severity="error" mt={3}>
            {t("m.document.notFound")}
          </AlertSpg>
        )}
        {!loading && !error && data && <SeRecognitionContent data={data} />}
      </AppPageContentWrapper>
    </PageWrapper>
  );
};

export default SeRecognitionQrView;
